export default {"src":"/_next/static/media/manufactureLogo2.82eefb68.svg","height":56,"width":120,"blurWidth":0,"blurHeight":0};